import script from "./restaurantInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./restaurantInfo.vue?vue&type=script&setup=true&lang=js"

import "./restaurantInfo.vue?vue&type=style&index=0&id=f77e0b42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f77e0b42"]])

export default __exports__